<template>
  <div class="cmp-wrapper">
    <basic-container>
      <data-display></data-display>
    </basic-container>
  </div>
</template>


<script>
import DataDisplay from "./../../../blocks/mc-data-display/index.js";

export default {
  name: "",
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {
    DataDisplay
  }
};
</script>


<style lang="scss" scoped>
.cmp-wrapper {
}
</style>
